import { render } from "./IntegrationProfile.vue?vue&type=template&id=9c4332a2&scoped=true&ts=true"
import script from "./IntegrationProfile.vue?vue&type=script&lang=ts&scoped=true"
export * from "./IntegrationProfile.vue?vue&type=script&lang=ts&scoped=true"

import "./IntegrationProfile.vue?vue&type=style&index=0&id=9c4332a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c4332a2"]])

export default __exports__